import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel, { FormLabelProps } from "@mui/material/FormLabel";
import MuiRadio from "@mui/material/Radio";
import RadioGroup, { RadioGroupProps } from "@mui/material/RadioGroup";
import { get } from "radash";
import { Controller, UseControllerProps } from "react-hook-form";





export type RadioOption = {
  value: string | boolean;
  label: string;
};

export type RadioProps = RadioGroupProps &
  UseControllerProps<any> & {
    label: string;
    options: RadioOption[];
    labelProps?: FormLabelProps;
  };

const Radio = (props: RadioProps) => {
  const { control, name, options, label, labelProps, ...rest } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, formState: state }) => (
        <FormControl error={!!get(state.errors, name)}>
          <FormLabel id="radio-group-label" {...labelProps}>{label}</FormLabel>
          <RadioGroup 
            {...field} 
            {...rest} 
            aria-labelledby="radio-group-label"
            onChange={(e) => {
              const value = e.target.value;
              const finalValue = value === 'true' ? true 
                : value === 'false' ? false 
                : value;
              field.onChange(finalValue);
            }}
          >
            {options.map((option) => (
              <FormControlLabel
                key={option.label}
                value={option.value}
                control={<MuiRadio color="error" />}
                label={option.label}
              />
            ))}
          </RadioGroup>
        </FormControl>
      )}
    />
  );
};

export default Radio;